import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { urlApi } from '../../../utils/apiConfig';

@Injectable()
export class WebhookService {

  constructor(private http: HttpClient) { 
    
  }

  public getHookNRCA(): Observable<any>{
    return this.http.get(`${urlApi}/admin/webhook/nrca`)
  }

  public updateHookNRCA(uri: string): Observable<any>{
    return this.http.patch(`${urlApi}/admin/webhook/update-hook-nrca`,{uri: uri})
  }
}
